import { ChapterMotionController } from "./controllers/chapter-motion";
import { GuidedTourController } from "./controllers/guided-tour";
import { InquiryController } from "./controllers/inquiry";
import { PromptArchiveController } from "./controllers/prompt-archive";
import { PwaOfflineController } from "./controllers/pwa-offline";
import { ScrollFilmController } from "./controllers/scroll-film";
import { SmoothScrollController } from "./controllers/smooth-scroll";

export interface Controller {
  mount(root: ParentNode): void;
  destroy(): void;
}

const controllers: Controller[] = [
  new SmoothScrollController(),
  new ScrollFilmController(),
  new ChapterMotionController(),
  new GuidedTourController(),
  new PromptArchiveController(),
  new InquiryController(),
  new PwaOfflineController()
];

let mounted = false;

export function mount(root: ParentNode = document): void {
  if (mounted) {
    destroy();
  }

  for (const controller of controllers) {
    controller.mount(root);
  }

  const shell = document.querySelector<HTMLElement>("#document-shell");
  if (shell?.dataset.title) {
    document.title = shell.dataset.title;
  }
  document.body.dataset.page = shell?.dataset.page ?? "";
  mounted = true;
}

export function destroy(): void {
  for (const controller of [...controllers].reverse()) {
    controller.destroy();
  }
  mounted = false;
}
